<mat-paginator [length]="length" [pageIndex]="pageIndex$ | async" [pageSize]="pageSize$ | async" [pageSizeOptions]="[10, 25, 100]" (page)="onPage($event)">
</mat-paginator>
